import { computed, ref } from '@vue/composition-api';
import { FILTER_PARAMS } from '@/constants/filters';
import isEmpty from 'lodash.isempty';
export const useObjectFilters = () => {
    const hiddenFilterTags = [
        FILTER_PARAMS.SORT_BY,
        FILTER_PARAMS.INTERNAL_STATUS,
    ];
    const filters = ref({
        [FILTER_PARAMS.STRUCTURE]: null,
        [FILTER_PARAMS.OBJECT_TYPES]: [],
        [FILTER_PARAMS.PLACES]: [],
        [FILTER_PARAMS.TAGS]: [],
        [FILTER_PARAMS.SEARCH]: '',
        [FILTER_PARAMS.INTERNAL_STATUS]: null,
        [FILTER_PARAMS.SORT_BY]: null,
        [FILTER_PARAMS.IS_IMPORTANT]: false,
        [FILTER_PARAMS.CENTRAL_COST]: null,
    });
    const multipleFilters = computed(() => {
        let multipleFilters = [];
        Object.entries(filters.value).map(([key, value]) => {
            if (Array.isArray(value)) {
                if (isEmpty(value)) {
                    return;
                }
                value.map((multipleFilterValue) => {
                    multipleFilters = [...multipleFilters, [key, multipleFilterValue]];
                });
            }
        });
        return multipleFilters;
    });
    const singleFilters = computed(() => {
        return Object.entries(filters.value).filter(([, value]) => {
            return !Array.isArray(value) && value;
        });
    });
    const omitHiddenFilterTags = (filterTags) => {
        return filterTags.filter(([key]) => {
            return (!hiddenFilterTags.includes(key) &&
                Object.values(FILTER_PARAMS).includes(key));
        });
    };
    const filterTags = computed(() => {
        const mergedFilters = [...multipleFilters.value, ...singleFilters.value];
        return omitHiddenFilterTags(mergedFilters);
    });
    const removeActiveFilter = (param, value) => {
        if (Array.isArray(filters.value[param])) {
            filters.value[param] = filters.value[param].filter((filterItem) => filterItem.id !== value.id);
            return;
        }
        filters.value[param] = null;
    };
    return {
        filters,
        filterTags,
        removeActiveFilter,
    };
};
